import { render, staticRenderFns } from "./index.vue?vue&type=template&id=46f95e2b&scoped=true&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"
import style0 from "./referenceValue.scss?vue&type=style&index=0&id=46f95e2b&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46f95e2b",
  null
  
)

export default component.exports